import React, { useState } from "react";
import ChevronDownIcon from "app/components/Icons/ChevronDownIcon";
import RightCaretIcon from "app/components/Icons/RightCaretIcon";
import NotificationTable from "./NotificationTable";
import { useDispatch } from "react-redux";
import { actions } from "app/containers/Features/containers/TeamSettings/container/Notification/redux/slice";
import { NOTIFICATION_SECTIONS } from "./type";



const NotificationList = () => {
  const dispatch = useDispatch();
  const [expandedSections, setExpandedSections] = useState<string[]>(
    NOTIFICATION_SECTIONS,
  );

  React.useEffect(() => {
    dispatch(actions.fetchNotificationsPreferences());
  }, []);

  const toggleSection = (section: string) => {
    setExpandedSections((prev) =>
      prev.includes(section)
        ? prev.filter((s) => s !== section)
        : [...prev, section],
    );
  };

  return (
    <div className="flex flex-col border border-gray-100 bg-white rounded-[4px] w-full overflow-hidden">
      {NOTIFICATION_SECTIONS.map((section, index) => {
        const isExpanded = expandedSections.includes(section);

        return (
          <div key={section} className="flex flex-col">
            <div
              className={`flex items-center px-4 h-[52px] cursor-pointer hover:bg-gray-50 transition-colors ${
                index !== NOTIFICATION_SECTIONS.length - 1 || isExpanded
                  ? "border-b border-gray-100"
                  : ""
              } ${isExpanded ? "bg-gray-400 border-x border-gray-100" : ""}`}
              onClick={() => toggleSection(section)}
            >
              <div className="mr-3 flex items-center justify-center">
                {isExpanded ? (
                  <ChevronDownIcon size={24} />
                ) : (
                  <RightCaretIcon size={24} />
                )}
              </div>

              <span
                className={`text-base font-medium leading-5 ${
                  isExpanded ? "text-primary" : "text-black"
                }`}
              >
                {section}
              </span>
            </div>

            {isExpanded && (
              <div
                className={`w-full ${
                  index !== NOTIFICATION_SECTIONS.length - 1
                    ? "border-b border-gray-100"
                    : ""
                }`}
              >
                <NotificationTable category={section} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NotificationList;
